import Moment from "moment/moment";

const useTime = () => {
    /**
     * Adds the given amount of days to a date and returns a new date
     *
     * @param {string} date
     * @param {number} days
     * @returns {string}
     */
    const addDaysToDate = (date, days) => {
        date = Moment(date, 'YYYY-MM-DD').add(days, 'days');
        return date.format('YYYY-MM-DD');
    }

    return {
        addDaysToDate
    }
}

export default useTime;
